// extracted by mini-css-extract-plugin
module.exports = {"app-footer":"AppFooter-9f8ce11f858cefca82ab19d5e0dbced0","appFooter":"AppFooter-9f8ce11f858cefca82ab19d5e0dbced0"};